module.exports = __webpack_public_path__ + "img/fail.d50505e1.svg";